// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ArrowSmallRightIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ArrowSmallRightIcon" ref={forwardedRef} {...props}>
      <path d="m9.757 5.757-1.06 1.061L11.879 10l-3.182 3.182 1.06 1.06L14 10z" />
      <path d="M12.504 10.75h-6v-1.5h6z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ArrowSmallRightIcon = /* @__PURE__ */ Object.assign(
  ArrowSmallRightIconComponent,
  { displayName: 'ArrowSmallRightIcon' },
);
